import React from "react";

export default function AboutServiceCard(props) {
  return (
    <div className="col-lg custom-width hbnb-service">
      <div className="hbnb-service-icon d-inline-flex">
        <i className={`fa-solid ${props.icon}`}></i>
      </div>
      <h5 className="mb-2">{props.heading}</h5>
      <p className="mb-2">{props.text}</p>
    </div>
  );
}
